import { useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { type MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import LanguageSelector, { type LanguageSelectorRef } from '../../../../LanguageSelector';

import s from './useLanguageItem.scss';

export function useLanguageItem(): (MenuItem & { key: string }) | false {
  const { t } = useTranslation();
  const languageSelectorRef = useRef<LanguageSelectorRef>(null);

  const handleRowClick = useCallback(() => {
    languageSelectorRef.current?.openModal();
  }, []);

  return {
    key: 'language-selector',
    label: t('siteHeader.userMenu.languageSelector.label'),
    suffix: (
      <span className={s['language-selector-item']}>
        <LanguageSelector
          ref={languageSelectorRef}
          displayOnly
          className={s['language-selector']}
        />
      </span>
    ),
    onClick: handleRowClick,
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      menu_name: 'profile',
      menu_item: 'language',
    }),
  };
}
